import { render, staticRenderFns } from "./customPage.vue?vue&type=template&id=1fed304c&scoped=true"
import script from "./customPage.vue?vue&type=script&lang=js"
export * from "./customPage.vue?vue&type=script&lang=js"
import style0 from "./customPage.vue?vue&type=style&index=0&id=1fed304c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fed304c",
  null
  
)

export default component.exports